// extracted by mini-css-extract-plugin
export default {"container":"CircleOptions_container__fprL5","title":"CircleOptions_title__0QSfC","description":"CircleOptions_description__FTvzI"};